import React from "react";
import ReactDOM from "react-dom/client";
// Merged global stylesheet (index.css + App.css combined, original order).
// The old two files are kept on disk for comparison/rollback — archive or
// delete them only after verifying the site looks unchanged.
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import "./global.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";


const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );


root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
